import styled from 'styled-components';
import { fontFamily, fontSize, fontWeight, screen, spacing } from 'theme';

export const StyledSection = styled.div`
  padding-top: ${spacing('xl5')};
  padding-bottom: ${spacing('xl5')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    gap: ${spacing('xl3')};
  }
`;

export const StyledInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
  min-width: 15rem;
  align-self: center;
`;

export const StyledOutputs = styled.div`
  display: flex;
  gap: ${spacing('xl4')};
`;

export const StyledOutput = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};

  @media (min-width: ${screen('md')}) {
    gap: ${spacing('md')};
  }
`;

export const StyledLabel = styled.span`
  font-weight: ${fontWeight('extraBold')};
  text-transform: uppercase;
  line-height: 1;
  font-size: ${fontSize('sm')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('md')};
  }
`;

export const StyledValue = styled.span`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize('xl3')};
  font-family: ${fontFamily('serif')};
  line-height: 1;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl5')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl7')};
  }
`;
